/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { EnvironmentSpecificService } from './environment-specific.service';
import { SocketIoModule } from 'ngx-socket-io';
import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { SafePipeModule } from 'safe-pipe';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import {VgCoreModule} from '@videogular/ngx-videogular/core';
import {VgControlsModule} from '@videogular/ngx-videogular/controls';
import {VgOverlayPlayModule} from '@videogular/ngx-videogular/overlay-play';
import {VgBufferingModule} from '@videogular/ngx-videogular/buffering';
import { io, Socket as IoSocket } from 'socket.io-client';

declare var getUrlVars;

@Injectable()
export class AppSocket extends Socket {
  
  constructor(
    private _envService: EnvironmentSpecificService,) {
    super({ url: _envService.envSpecific.appUrl, 
    options: {
      path:_envService.envSpecific.wsPath,
      transports: ['websocket'],  // https://stackoverflow.com/a/52180905/8987128
      upgrade: false,
      query:  { token : JSON.parse(localStorage.getItem("currentUser")).socketToken },
      reconnection: true
    } });
  }

  //"_envService.envSpecific.apiUrl.replace("/api","copssocket")"
  
}


@Injectable()
export class ApiSocket extends Socket {

  constructor(
    private _envService: EnvironmentSpecificService,) {
    super({ url: _envService.envSpecific.apiUrl.replace('/api',''), 
    options: {
      path: '/quickteluserapisocket',
      transports: ['websocket'],  // https://stackoverflow.com/a/52180905/8987128
      upgrade: false,
      reconnection: true
    } });
  }

}

@Injectable({
     providedIn: 'root',
})
export class AppForPublicSocket {
  private socket!: IoSocket;
  constructor(
    private _envService: EnvironmentSpecificService) {
 
  }

  //"_envService.envSpecific.apiUrl.replace("/api","copssocket")"

  connect(token){
    this.socket = io(this._envService.envSpecific.appUrl, {
      path: this._envService.envSpecific.wsPath,
      transports: ['websocket'],
      query:  { token : token},
      reconnection: true
    });
  }
  
  getSocket(){
    return this.socket;
  }

  
}

import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbTimepickerModule
} from '@nebular/theme';
import { SharedModule } from './pages/shared/shared.module';
import { ToastrModule } from 'ngx-toastr';
import { Http } from './pages/shared/http-client/http-client.component';
import { AgmCoreModule } from '@agm/core';
import { PublicSharedModule } from './pages/public-shared/public-shared.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    SharedModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000,
      closeButton: true,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      enableHtml: true,
      maxOpened: 3
    }),
    SocketIoModule,
    SafePipeModule,
    PickerModule,
    NbTimepickerModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDyIqn2j3JTEloO8XB3resXPVLhbuudA1c',
      libraries: ['places']
    }),
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    PublicSharedModule.forRoot()
  ],
  bootstrap: [AppComponent],
  providers:[
    EnvironmentSpecificService,
    Http,
    AppSocket,
    ApiSocket,
    AppForPublicSocket
  ]
})
export class AppModule {
}
